module.exports = __webpack_public_path__ + "img/Player202106.b29e780d.png";